import React, { useEffect, useRef, useState } from 'react';
import Popup from 'reactjs-popup';
import { Link, useParams } from 'react-router-dom';
import { SingleBusinessData, UpdateBusiness } from '../../../../store/actions/new/businessAction';
import { useDispatch } from 'react-redux';
import { TagsInput } from 'react-tag-input-component';

const UpdateBusinessServices = ({ openModal, setOpen, type, onSubmitResponse, singleBusiness }) => {
    const [error, setError] = useState(null);
    const [isProcessing, setIsProcessing] = useState(false); 
    const closeModal = () => setOpen(false);
    const { id } = useParams();
    const dispatch = useDispatch()
    const [selected, setSelected] = useState([]);
    const [formData, setFormData] = useState({
        id: id,
        columns: {
            services: ''
        }
    });
    useEffect(() => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            columns: {
                ...prevFormData.columns,
                services: selected 
            }
        }));
    }, [selected]);
    useEffect(() => {
        if (singleBusiness && Object.keys(singleBusiness).length > 0) {
            const namesArray = 
            singleBusiness && 
            singleBusiness.services && 
            singleBusiness.services.data ? 
            singleBusiness.services.data.map(item => item.name) : 
            [];
            setSelected(
                namesArray
            ); 
        }
    }, [singleBusiness, openModal]);


    const handleSubmit = async (e) => {
        e.preventDefault();
        const response = await dispatch(UpdateBusiness(formData));
        if(response.status >= 200 && response.status < 300){
            setOpen(false)
        }
    };
 

    return (
        <div>
            <Popup open={openModal} closeOnDocumentClick onClose={closeModal} lockScroll={true}>
                <div className="modal">
                    <div className="modal-header">
                        <h3>Update {type}</h3>
                        <Link className="close" onClick={closeModal}>
                          &times;
                        </Link>
                    </div>
                    <div className="modal-content">
                        <form className="modal-form-wrapper" onSubmit={handleSubmit}>
                        <div className="sng-content-repeater"> 
                            <div className="sng-content">
                                <label>Product or Service</label>

                                <TagsInput
                                    value={selected}
                                    onChange={setSelected}
                                    name="productService"
                                    placeHolder="Add category"
                                    classNames="sett-form-input"
                                />

                            </div>
                        </div>
                            {error && <p className="error">{error}</p>}
                            <div className="text-right">
                                 <button type="submit" className="btn btn-submit" disabled={isProcessing}>
                                    {isProcessing ? 'Processing...' : 'Update'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </Popup>
        </div>
    );
};

export default UpdateBusinessServices;